import { CheckIcon } from '@heroicons/react/16/solid';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { AxiosError } from 'axios';
import Button from 'components/inputs/button';
import NumberInput from 'components/inputs/number';
import Text from 'components/inputs/text';
import {
  setAttomData,
  setLocationData,
  setWeatherData,
  updateProjectSetting
} from 'features/project';
import { useState } from 'react';
import { getLocationData, getWeatherData } from 'utils/data';
import { getProjectSettingValue } from 'utils/project';
import { errorModal, warningModal } from 'utils/ui';

export default function ZipCodeInfo() {
  const dispatch = useAppDispatch();
  const { locationData } = useAppSelector((state) => state.project);
  const [zipCodeInput, setZipCodeInput] = useState(locationData?.zipcode ?? '');
  const existingYearBuilt = getProjectSettingValue('year_built');
  const [yearBuiltInput, setYearBuiltInput] = useState<number | ''>(
    existingYearBuilt && !Number.isNaN(existingYearBuilt)
      ? existingYearBuilt
      : ''
  );
  const [loading, setLoading] = useState(false);
  const [saved, setSaved] = useState(false);

  const handleSave = async () => {
    setLoading(true);
    if (
      zipCodeInput &&
      zipCodeInput.length === 5 &&
      !Number.isNaN(Number(zipCodeInput))
    ) {
      if (
        yearBuiltInput &&
        yearBuiltInput.toString().length === 4 &&
        !Number.isNaN(yearBuiltInput)
      ) {
        dispatch(setAttomData(null));
        dispatch(
          updateProjectSetting({
            attributeCode: 'year_built',
            value: yearBuiltInput
          })
        );
        getLocationData(zipCodeInput)
          .then((res) => {
            dispatch(setLocationData(res.data ?? null));
            getWeatherData(zipCodeInput)
              .then((weatherData) => {
                dispatch(setWeatherData(weatherData));
                setSaved(true);
                setLoading(false);
              })
              .catch((error: AxiosError) => {
                warningModal('Failed to load weather data');
                console.error('Error fetching weather data', error);
                setLoading(false);
              });
          })
          .catch((error: AxiosError) => {
            warningModal('Failed to load location data');
            console.error('Error fetching location data', error);
            setLoading(false);
          });
      } else {
        errorModal('Please enter a valid year');
        setLoading(false);
      }
    } else {
      errorModal('Please enter a valid zip code');
      setLoading(false);
    }
  };

  const handleKeyPress = (key: string) => {
    if (key === 'Enter') {
      handleSave();
    }
  };

  return (
    <div className='flex items-center gap-3'>
      <Text
        value={zipCodeInput}
        onChange={(value) => setZipCodeInput(value)}
        onKeyUp={(e) => handleKeyPress(e.key)}
        placeholder='Enter zip code'
      />
      <NumberInput
        value={yearBuiltInput}
        onChange={(value) => setYearBuiltInput(value ?? '')}
        placeholder='Enter year built'
      />
      <Button
        color='primary'
        text={saved ? 'Saved' : 'Save'}
        onClick={handleSave}
        icon={saved ? CheckIcon : undefined}
        loading={loading}
        disabled={loading}
      />
    </div>
  );
}
